import React from "react";
import { Skeleton } from "antd";
import styled from "styled-components/macro";

const CardsSkeleton = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  .skeleton-card .ant-skeleton-title {
    height: 155px;
  }
`;

const SkeletonCard = styled.article`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  border: none;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  transition: 0.3s ease;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 25px;
  width: 100%;
  max-width: 240px;
`;

const SkeletonNumber = styled.div`
  flex: initial;
  height: 50px;
  overflow: hidden;
  width: 80px;
  margin-top: 20px;
`;

const SkeletonTitle = styled.div`
  flex: initial;
  height: 40px;
  margin-top: 20px;
  overflow: hidden;
  margin-bottom: 30px;
`;

const SkeletonCountContainer = styled.section`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  justify-content: space-between;
  max-width: 560px;
  margin-right: 20px;
`;

const SkeletonChartContainer = styled.section`
  max-width: 500px;
  flex: 1 1 500px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SkeletonCircle = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  .ant-skeleton-title {
    margin-top: 0 !important;
  }
`;

const SkeletonAnalytics = () => {
  return (
    <CardsSkeleton>
      <SkeletonChartContainer>
        <SkeletonCircle>
          <Skeleton
            className="skeleton-card"
            active
            avatar={false}
            title={{ rows: 1 }}
            paragraph={false}
          />
        </SkeletonCircle>
      </SkeletonChartContainer>
      <SkeletonCountContainer>
        <SkeletonCard>
          <SkeletonNumber>
            <Skeleton
              className="skeleton-card"
              active
              avatar={false}
              title={{ rows: 1 }}
              paragraph={false}
            />
          </SkeletonNumber>
          <SkeletonTitle>
            <Skeleton
              className="skeleton-card"
              active
              avatar={false}
              title={{ width: 100, rows: 1 }}
              paragraph={false}
            />
          </SkeletonTitle>
        </SkeletonCard>
        <SkeletonCard>
          <SkeletonNumber>
            <Skeleton
              className="skeleton-card"
              active
              avatar={false}
              title={{ rows: 1 }}
              paragraph={false}
            />
          </SkeletonNumber>
          <SkeletonTitle>
            <Skeleton
              className="skeleton-card"
              active
              avatar={false}
              title={{ width: 100, rows: 1 }}
              paragraph={false}
            />
          </SkeletonTitle>
        </SkeletonCard>
        <SkeletonCard>
          <SkeletonNumber>
            <Skeleton
              className="skeleton-card"
              active
              avatar={false}
              title={{ rows: 1 }}
              paragraph={false}
            />
          </SkeletonNumber>
          <SkeletonTitle>
            <Skeleton
              className="skeleton-card"
              active
              avatar={false}
              title={{ width: 100, rows: 1 }}
              paragraph={false}
            />
          </SkeletonTitle>
        </SkeletonCard>
        <SkeletonCard>
          <SkeletonNumber>
            <Skeleton
              className="skeleton-card"
              active
              avatar={false}
              title={{ rows: 1 }}
              paragraph={false}
            />
          </SkeletonNumber>
          <SkeletonTitle>
            <Skeleton
              className="skeleton-card"
              active
              avatar={false}
              title={{ width: 100, rows: 1 }}
              paragraph={false}
            />
          </SkeletonTitle>
        </SkeletonCard>
      </SkeletonCountContainer>
    </CardsSkeleton>
  );
};

export default SkeletonAnalytics;
